import PropTypes from 'prop-types';

export const OEOfflineManagerProps = {

    controller: {
        className:                      PropTypes.string,
        moduleId:                       PropTypes.string,
        showTitle:                      PropTypes.bool,
        hideWithoutWorkspaceUpdate:     PropTypes.bool
    }
};

OEOfflineManagerProps.controllerDefaultProps = {
    className:                          '',
    moduleId:                           '',
    showTitle:                          true,
    hideWithoutWorkspaceUpdate:         false
};